import { useQuery } from '@tanstack/react-query';
import { UsersService } from '../services';
import { usersKeys } from '../queryKeys';

/**
 * How many locations each identity on the current page can access.
 *
 * A separate query from the list because the counts live in
 * organization-service: the list must not wait on it, and must not fail with
 * it. An id with no entry in `countsById` is one whose count has not arrived.
 *
 * @param {string[]} identityIds - The ids of the rows on screen.
 */
export const useGetIdentityLocationCounts = (identityIds) => {
  const { data, isError } = useQuery({
    queryKey: usersKeys.identityLocationCounts(identityIds),
    queryFn: () => UsersService.getIdentityLocationCounts(identityIds),
    enabled: identityIds.length > 0,
    retry: false,
  });

  return {
    countsById: data ?? {},
    isError,
  };
};
